export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5315.b726eebb.jpg";